//
// ─── IMPORTING NECESSARY ELEMENTS ───────────────────────────────────────
//
import React from 'react';
import { formatDistanceTime, formatDate, formatData, getValue } from '../contexts/Utils';
import { PenaltiesList } from '../contexts/Contexts'
import Api from '../contexts/Api'
import { Link, useNavigate } from 'react-router-dom';
import styled from "styled-components";
import TitleSeparator from './BaseComponents/TitleSeparator';

//
// ─── COMPONENT DECLARATION ───────────────────────────────────────
//
const Mission = (props) => {
  let data = props.data;
  const navigate = useNavigate();

  let penalties = 0;

  PenaltiesList.map((penalty) => {
    if (data[penalty.name]) {
      penalties += data[penalty.name];
    }
  })

  // const handleReplicate = async (e, mission_id) => {
  //   e.preventDefault();
  //   const duplicateMission = await Api({ endpoint: '/missions/replicate', data: { mission_id } });

  //   if (duplicateMission.success) {
  //     navigate(`/editer/${duplicateMission.data.mission_id}`);
  //   }
  // }

  const handleView = () => {
    navigate(`${window.location.pathname !== '/' ? window.location.pathname : '/mission'}/${data.uuid}`);
  }

  const hasProposals = Boolean(data.driver_count) && data.status <= 2;
  const hasViews = Boolean(data.user_count) && data.status <= 5;

  let vehicleIcon = <S.Vehicle xmlns="http://www.w3.org/2000/svg" width='24' height='24' viewBox="0 0 640 512"><path d="M640 320V368C640 385.7 625.7 400 608 400H574.7C567.1 445.4 527.6 480 480 480C432.4 480 392.9 445.4 385.3 400H254.7C247.1 445.4 207.6 480 160 480C112.4 480 72.94 445.4 65.33 400H32C14.33 400 0 385.7 0 368V256C0 224.5 22.78 198.3 52.78 192.1L97.05 82.29C109.2 51.92 138.6 32 171.3 32H353.2C377.5 32 400.5 43.05 415.7 62.02L519.9 192.2C586.9 196.3 640 251.1 640 320H640zM171.3 64C151.7 64 134.1 75.95 126.8 94.17L87.63 192H224V64H171.3zM256 192H478.7L390.7 82.01C381.6 70.63 367.8 64 353.2 64H256L256 192zM541.1 400C543.3 394.9 544 389.5 544 384C544 378.5 543.3 373.1 541.1 368C534.9 340.4 509.8 320 480 320C450.2 320 425.1 340.4 418 368C416.7 373.1 416 378.5 416 384C416 389.5 416.7 394.9 418 400C425.1 427.6 450.2 448 480 448C509.8 448 534.9 427.6 541.1 400zM385.3 368C392.9 322.6 432.4 288 480 288C527.6 288 567.1 322.6 574.7 368H608V320C608 266.1 565 224 512 224H64C46.33 224 32 238.3 32 256V368H65.33C72.94 322.6 112.4 288 160 288C207.6 288 247.1 322.6 254.7 368H385.3zM221.1 400C223.3 394.9 224 389.5 224 384C224 378.5 223.3 373.1 221.1 368C214.9 340.4 189.8 320 160 320C130.2 320 105.1 340.4 98.02 368C96.7 373.1 96 378.5 96 384C96 389.5 96.7 394.9 98.02 400C105.1 427.6 130.2 448 160 448C189.8 448 214.9 427.6 221.1 400z" /></S.Vehicle>

  if (data.vehicle_type === 2) {
    vehicleIcon = <S.Vehicle xmlns="http://www.w3.org/2000/svg" width='24' height='24' viewBox="0 0 640 512"><path d="M64 416C28.65 416 0 387.3 0 352V64C0 28.65 28.65 0 64 0H352C387.3 0 416 28.65 416 64V96H481.3C495.3 96 508.6 102.1 517.7 112.8L596.4 204.6C603.9 213.3 608 224.4 608 235.8V384H624C632.8 384 640 391.2 640 400C640 408.8 632.8 416 624 416H576C576 469 533 512 480 512C426.1 512 384 469 384 416H255.1C255.1 469 213 512 159.1 512C106.1 512 63.1 469 63.1 416H64zM32 64V352C32 369.7 46.33 384 64 384H69.46C82.64 346.7 118.2 320 160 320C201.8 320 237.4 346.7 250.5 384H384V64C384 46.33 369.7 32 352 32H64C46.33 32 32 46.33 32 64zM570.9 224L493.4 133.6C490.4 130 485.1 128 481.3 128H416V224H570.9zM416 256V344.4C432.1 329.2 455.4 320 480 320C521.8 320 557.4 346.7 570.5 384H576V256H416zM160 352C124.7 352 96 380.7 96 416C96 451.3 124.7 480 160 480C195.3 480 224 451.3 224 416C224 380.7 195.3 352 160 352zM480 480C515.3 480 544 451.3 544 416C544 380.7 515.3 352 480 352C444.7 352 416 380.7 416 416C416 451.3 444.7 480 480 480z" /></S.Vehicle>
  } else if (data.vehicle_type === 3) {
    vehicleIcon = <S.Vehicle xmlns="http://www.w3.org/2000/svg" width='24' height='24' viewBox="0 0 640 512"><path d="M640 250.7V360C640 379.4 626.3 395.5 607.1 399.2L608 400C608 444.2 572.2 480 528 480C483.8 480 448 444.2 448 400H288C288 444.2 252.2 480 208 480C181.8 480 158.6 467.4 144 448C129.4 467.4 106.2 480 80 480C35.82 480 0 444.2 0 400V104C0 64.24 32.24 32 72 32H408C447.8 32 480 64.24 480 104V128H536C551.1 128 565.3 135.1 574.4 147.2L630.4 221.9C636.6 230.2 640 240.3 640 250.7zM32 104V335.1C45.37 325.1 61.99 320 80 320C106.2 320 129.4 332.6 144 351.1C158.6 332.6 181.8 320 208 320C240.8 320 268.1 339.7 281.3 368H448V104C448 81.91 430.1 64 408 64H72C49.91 64 32 81.91 32 104zM528 320C560.8 320 588.9 339.7 601.3 367.9C605.1 367.3 608 363.1 608 360V256H480V335.1C493.4 325.1 509.1 320 528 320zM480 160V224H592L548.8 166.4C545.8 162.4 541 160 536 160H480zM528 448C554.5 448 576 426.5 576 400C576 373.5 554.5 352 528 352C501.5 352 480 373.5 480 400C480 426.5 501.5 448 528 448zM208 352C181.5 352 160 373.5 160 400C160 426.5 181.5 448 208 448C234.5 448 256 426.5 256 400C256 373.5 234.5 352 208 352zM80 448C106.5 448 128 426.5 128 400C128 373.5 106.5 352 80 352C53.49 352 32 373.5 32 400C32 426.5 53.49 448 80 448z" /></S.Vehicle>
  }

  //
  // ─── COMPONENT RENDER ───────────────────────────────────────
  //
  return (
    <S.Card onClick={handleView}>
      <S.Header>
        <div className='row'>
          <h3>{data.company}</h3>
          {props.role === 'super-admin' && <div className='row'>
            <Link to={`/dupliquer`}>
              <svg style={{ pointerEvents: 'none' }} xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-copy" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M7 7m0 2.667a2.667 2.667 0 0 1 2.667 -2.667h8.666a2.667 2.667 0 0 1 2.667 2.667v8.666a2.667 2.667 0 0 1 -2.667 2.667h-8.666a2.667 2.667 0 0 1 -2.667 -2.667z" /><path d="M4.012 16.737a2.005 2.005 0 0 1 -1.012 -1.737v-10c0 -1.1 .9 -2 2 -2h10c.75 0 1.158 .385 1.5 1" /></svg>
            </Link>
          </div>}
        </div>
        <div className='row margin-top-small'>
          <div> Véhicule : {data.vehicle_brand} {data.vehicle_model}<br />Type de véhicule : {vehicleIcon}</div>
          {Boolean(data.recovery) && <span className='bold'>Aller / Retour</span>}
        </div>
        <div className='row margin-top mobile'>
          <div className='columns'>
            <span>Disponibilité du véhicule : <br /><span className='bold small'>{`${formatDate({ time: data.vehicle_availability, display: 'date' })}`}</span></span>

          </div>
          {data.recovery_date && <div className='columns'>
            <span>Récupération : </span>
            <span className='bold small'>{`${formatDate({ time: data.recovery_date, display: 'date' })}`}</span>
          </div>}
          {data.delivery_date && <div className='columns'>
            <span>Livraison : </span>
            <span className='bold small'>{`${formatDate({ time: data.delivery_date, display: 'date' })}`}</span>
          </div>}
          {data.recovery_delivery_date && <div className='columns'>
            <span>Retour :</span>
            <span className='bold small'>{`${formatDate({ time: data.recovery_delivery_date, display: 'date' })}`}</span>
          </div>}
        </div>
        {data.referent_email && <div className='row margin-top'>
          <span>Coordonnées du référent : {data.referent_firstname} {data.referent_phone}</span>
        </div>}
      </S.Header>
      <S.FirstRow>
        <S.Infos>
          <TitleSeparator title='Prix' />
          {props.role !== 'garage' && <div>Prix convoyeur : <S.DriverPrice $urgent={data.urgent} className='bold' >{data.price_driver}€</S.DriverPrice>{Boolean(data.urgent) && <S.PriceReduced className='bold'> {Math.round(data.price_driver * 0.9)}€</S.PriceReduced>}</div>}
          {props?.role !== 'driver' && <div>Prix garage :<span className='bold'>{data.price}€ HT</span></div>}
        </S.Infos>
        <S.Infos>
          <TitleSeparator title='Infos trajet' />
          <div>Temps: <span className='bold'>{formatDistanceTime({ duration: data.duration })}</span></div>
          <div>Distance : <span className='bold'>{formatDistanceTime({ distance: data.distance })}</span></div>
        </S.Infos>
        <S.Date>
          <div>Date de livraison :</div>
          <div className='bold'>{` ${data.date_type !== 2 ? window._DATA.date_type[data.date_type].label : ''} ${formatDate({ time: data.date, display: 'date' })} ${data.time ? `- ${data.time.replace(':', 'h')}` : ''}`}</div>
        </S.Date>
      </S.FirstRow>

      <S.SecondRow>
        <S.Steps $height={data.recovery_address ? true : false}>
          <S.Circle className='empty'></S.Circle>
          <S.Line></S.Line>
          <S.Circle className="damier"></S.Circle>
          {data.recovery_address && <>
            <S.Line></S.Line>
            <S.Circle className="empty"></S.Circle>
          </>}
        </S.Steps>
        <S.Adresses>
          <div>{data.origin_address ? `${data.origin_address}, ${data.origin_cp} ${data.origin_city}` : `${data.origin_city} ${data.origin_cp}`}</div>
          <div>{data.destination_address ? `${data.destination_address}, ${data.destination_cp} ${data.destination_city}` : `${data.destination_city} ${data.destination_cp}`}</div>
          {data.recovery_address && <div>{data.recovery_address.destination_address ? `${data.recovery_address.destination_address}, ${data.recovery_address.destination_cp} ${data.recovery_address.destination_city}` : `${data.recovery_address.destination_city} ${data.recovery_address.destination_cp}`}</div>}
        </S.Adresses>
      </S.SecondRow>

      <S.Footer>
        <div className='reference'>N°{data.reference}</div>
        {props.role === 'super-admin' && (hasProposals || hasViews) && <div className='flex'>
          {hasProposals && `${data.driver_count} proposition${data.driver_count > 1 ? 's' : ''} -`}
          {hasViews && ` ${data.user_count} vue${data.user_count > 1 ? 's' : ''}`}
        </div>}
        {Boolean(penalties) && <div className='penalty'>Une pénalité de {penalties}€ à été appliquée à la mission</div>}
        <div className={(data.status === 3 && props.role === 'super-admin') ? 'status-to-validate' : 'status'}>{props.is_search ? getValue(window, ['_DATA', 'mission_status', data.status, 'label']) : 'Disponible'}</div>
      </S.Footer>

    </S.Card>
  );
};

export default Mission;

let S = {};

S.Card = styled.div`
  text-decoration: none;
  background: #FFF;
  box-shadow: 0 20px 27px 0 rgb(0 ,0, 0, 5%);
  color: var(--text-color);
  border-radius: 5px;
  height: 100%;
  display: flex;
  flex-direction: column;

  & .bold {
    font-weight: bold;
    font-size: 18px;
  }

  &:hover {
    cursor: pointer;
  }

  @media (max-width: 700px) {
    width: 100%;
    box-sizing: border-box;
  }
`;

S.Header = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 20px;

  & h3 {
    margin: 0;
    color: var(--primary-color);
  }

  & span {
    color: var(--light-grey);
  }

  & .columns {
    display: flex;
    flex-direction: column;
    gap: 5px;
  }

  & .row {
    display: flex;
    justify-content: space-between;
    gap: 10px;

    & svg {
      color: var(--light-grey);
      width: 20px;
      height: 20px;
    }
  }

  & .margin-top {
    margin-top: 15px;
  }

  & .margin-top-small {
    margin-top: 5px;
  }

  & .bold {
    font-weight: bold;
    color: var(--primary-color);
  }

  & .small {
    font-size: 16px;
  }

  & .flex {
    display: flex;
    flex-direction: column;
    gap: 5px;
  }

  @media (max-width: 700px) {
    .mobile {
      flex-direction: column;
    }
  }
`;

S.FirstRow = styled.div`
  display: flex;
  justify-content: space-between;
  padding-left: 20px;
  gap: 20px;
  align-items: stretch;
  height: 100%;

  @media (max-width: 700px) {
    flex-direction: column;
    padding-left: 0;
  }
`;

S.Infos = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex: 1;
  padding-top: 10px;
  padding-bottom: 10px;

  & .bold {
    color: var(--primary-color);
  }

  @media (max-width: 700px) {
    padding-left: 20px;
  }
`

S.Date = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  color: var(--white);
  background: var(--secondary-color);
  border-top-left-radius: 5px;
  padding: 20px;

  @media (max-width: 700px) {
    border-top-right-radius: 5px;
  }
`

S.SecondRow = styled.div`
  display: flex;
  gap: 30px;
  background: rgba(137, 205, 168, 0.3);
  padding: 20px;
`;

S.Steps = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: center;
  justify-content: space-between;
  position: relative;
  & .empty {
    background: var(--white);
  }

  & .damier {
    background-color: var(--primary-color);
    background-image: linear-gradient(45deg, #FFF 25%, transparent 25%, transparent 75%, #FFF 75%), linear-gradient(45deg, #FFF 25%, transparent 25%, transparent 75%, #FFF 75%);
    background-size: 8px 8px;
    background-position: -2px -2px, 50px 50px;
    border-color:var(--primary-color);
  }
`;

S.Circle = styled.div`
  min-width: 18px;
  min-height: 18px;
  background: var(--primary-color);
  border: 2px solid var(--primary-color);
  border-radius: 100%;
  z-index: 90;
`;

S.Line = styled.div`
  width: 100%;
  height: 20px;
  border-left: 2px dotted var(--primary-color);
  margin-left: 22px;
  /* position: absolute; */
  /* top: 0;
  left: 50%; */
`;

S.Adresses = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 20px;
  color: var(--primary-color);
`;

S.Footer = styled.div`
  display: flex;

  & div {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px;
    flex: 1;
    font-size: 15px;
  }

  & .columns {
    flex-direction: column;
  }

  & .reference {
    background: var(--card-dark);
    border-bottom-left-radius: 5px;
    color: var(--white);
  }

  & .proposals, .views {
    background: var(--white);
    color: var(--text-color);
  }

  & .penalty {
    background: var(--card-dark);
    color: var(--white);
  }

  & .status {
    background: var(--secondary-color);
    border-bottom-right-radius: 5px;
    color: var(--white);
    text-align: center;
  }

  & .status-to-validate {
    background: #fea347;
    border-bottom-right-radius: 5px;
    color: var(--white);
    text-align: center;
  }

  @media (max-width: 700px) {
    flex-direction: column;

    & .reference {
      border-bottom-left-radius: 0px;
    }

    & .status {
      border-bottom-left-radius: 5px;
    }

    & .status-to-validate {
      border-bottom-left-radius: 5px;
    }
  }
`

S.DriverPrice = styled.span`
  position:relative;
  &:after{
    content:' ';
    display:${({ $urgent }) => $urgent ? 'block' : 'none'};
    width:100%;
    height:3px;
    background:#d03131;
    position: absolute;
    top:50%;
    left:0;
    transform: translateY(-50%) rotate(-10deg);
  }
`

S.PriceReduced = styled.span`
  margin-right: 10px;
`


S.Vehicle = styled.svg`
  transform:translateY(5px)
`